import { useState } from 'react';
import { useStateValue } from 'state/index';
import download from 'downloadjs';
import { downloadReport } from '../queries';
import { onException } from "state/httpStatusHandler";

const useReport = () => {
  const [state, dispatch] = useStateValue();
  const [isLoading, setIsLoading] = useState(false);

  const request = async (hash, filters, callback) => {
    setIsLoading(true);

    await downloadReport(hash, filters)
      .then (response => {
        if (response && response.status === 200) {
          const contentDisposition = response.headers['content-disposition'];
          const fileReader = new FileReader();

          fileReader.onload = () => {
            let result = [];

            if (response.data.type === 'application/json') {
              result = JSON.parse(fileReader.result);
            }

            if (result.error) {
              onException({response: {status: 500, data: result}}, dispatch, state);
              return;
            }

            if (result.redirect === true) {
              window.location.href = result.location;
              return;
            }

            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(
                /filename=(?<filename>.*)/
              );
              if (
                Object.prototype.hasOwnProperty.call(
                  fileNameMatch.groups,
                  'filename'
                )
              ) {
                download(response.data, fileNameMatch.groups.filename);
                callback();
              }
            }
          };
          fileReader.readAsText(response.data);
        }
      })
      .catch(errorObject => onException(errorObject, dispatch, state));

    setIsLoading(false);
  };

  return [isLoading, request];
};

export default useReport;
